import { Link, Typography } from "@mui/material";
import backgroundImage from "../../assets/images/background.jpg";
import logo from "../../assets/images/havefun-logo.png";
import styles from "./Maintenance.module.css";
import { useEffect } from "react";
import { useAppDispatch } from "../../config/hooks";
import { getOrganisation } from "../Home/HomeApi";
import { getPublicHolidaysWithEves } from "../Home/utils/getPublicHolidaysWithEve";
import { DATE_FORMAT, TIMEZONE } from "../../config/helper";
import { useHistory } from "react-router-dom";
import momentTz from "moment-timezone";

const Maintenance = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const bgStyle = {
    background: `lightgray url(${backgroundImage}) 50% / cover no-repeat`,
    display: "flex",
    FlexDirection: "column",
    minHeight: "100vh",
    alignItems: "stretch",
  };

  // TODO: This is a temporary function to "shut down" the site to prevent booking on certain dates durin trial period
  const filterDate = (date: moment.Moment) => {
    // if ([0, 5, 6].includes(date.day())) return false; // Uncomment this if you want the booking portal to be accessible on Friday, Saturday and Sunday

    // Auto route to /maintenance on EVE of public holidays
    // const holidayWithEves = getPublicHolidaysWithEves();
    // const formattedHolidayWithEves = holidayWithEves.map((d) =>
    //   d.format(DATE_FORMAT)
    // );

    // const formattedDate = date.tz(TIMEZONE).format(DATE_FORMAT);

    // if (formattedHolidayWithEves.includes(formattedDate)) {
    //   return false;
    // }

    return true;
  };

  useEffect(() => {
    dispatch(getOrganisation());
    const allowAccess = filterDate(momentTz().tz(TIMEZONE));
    if (allowAccess) history.push("/");
  }, []);

  return (
    <div className={styles.Page} style={bgStyle}>
      <div className={styles.PageContainer}>
        <div className={styles.Container}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img alt="HaveFun Logo" src={logo} width={110} />
          </div>
          <div style={{ marginTop: "26px" }}>
            <Typography sx={{ my: 1 }}>
              Online booking is currently unavailable
            </Typography>
            <Typography sx={{ my: 1 }}>
              Please contact our outlet directly to make a booking:
            </Typography>
            <Link href="https://havefunkaraoke.com/our-outlets/" sx={{ my: 1 }}>
              https://havefunkaraoke.com/our-outlets/
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
